import React, { Component } from 'react';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';
import { WAButton } from '../components/Button.js';
import RenderField from "./RenderField";
import StatesList from '../containers/StatesContainer.js';
import CustomAutosuggestMobileFriendly from "./CustomAutosuggestMobileFriendly";
import {connect} from "react-redux";


class AdditionalPersonalInfoForm extends Component {

    constructor(props) {
        super(props);
        this.state = {};

    }

    render() {
        const { handleSubmit, submitting, error, real_address_state_id, work_address_state_id } = this.props;
        const reason_financial_aid = [{id: 0, name: 'Solventar gastos ocasionados por enfermedades'},{id: 1, name: 'Adquirir elementos de estudio'},{id: 2, name: 'Pagar viajes de turismo, de estudio y prácticas deportivas'},{id: 3, name: 'Adquirir la vivienda propia, efectuar ampliaciones o mejoras y gastos de escrituración'},{id: 4, name: 'Adquirir bienes muebles, y/o automotores'},{id: 5, name: 'Mantenimiento o formación de un capital de trabajo'},{id: 6, name: 'Otros'}];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_additional_personal_info" defaultMessage={"<p></br>Por favor confirmanos tu información de socio y domicilio</p>"}  description="Additional Personal info"/>
                        <WAButton phone={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveAdditionalPersonalInfo)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_file_code" autoComplete="off" component={RenderField} type="number" maxLength={6} label="Código estadístico" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="reason_financial_aid" defaultValue="Motivo de la ayuda económica" label="Motivo de la ayuda económica" attributeName='reason_financial_aid' attributeOptions={reason_financial_aid} />
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <label className="control-label">Domicilio Real:</label>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <StatesList name={'real_address_state_id'} />
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="real_address_locality" autoComplete="asd" component={CustomAutosuggestMobileFriendly} selectedState={real_address_state_id} type="text" label="Localidad" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="real_address_street" autoComplete="off" component={RenderField} type="text" label="Dirección" />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="real_address_zip_code" autoComplete="off" component={RenderField} type="number" label="Código Postal" />
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <label className="control-label">Domicilio Laboral:</label>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <StatesList name={'work_address_state_id'} />
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_address_locality" autoComplete="asd" component={CustomAutosuggestMobileFriendly} selectedState={work_address_state_id} type="text" label="Localidad" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_address_street" autoComplete="off" component={RenderField} type="text" label="Dirección" />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_address_zip_code" autoComplete="off" component={RenderField} type="number" label="Código Postal" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

AdditionalPersonalInfoForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([
    {name: 'work_file_code', required: false},
    {name: 'reason_financial_aid', required: true},
    {name: 'real_address_state_id', required: true},
    {name: 'real_address_locality', required: true},
    {name: 'real_address_street', required: true},
    {name: 'real_address_zip_code', required: true},
    {name: 'work_address_state_id', required: true},
    {name: 'work_address_locality', required: true},
    {name: 'work_address_street', required: true},
    {name: 'work_address_zip_code', required: true}
]);

const selector = formValueSelector('AdditionalPersonalInfoForm')

AdditionalPersonalInfoForm = connect(
    state => {
        const real_address_state_id = selector(state, 'real_address_state_id');
        const real_address_locality = selector(state, 'real_address_locality');
        const work_address_state_id = selector(state, 'work_address_state_id');
        const work_address_locality = selector(state, 'work_address_locality');

        return {
            real_address_state_id,
            real_address_locality,
            work_address_state_id,
            work_address_locality
        }
    }
)(AdditionalPersonalInfoForm)

AdditionalPersonalInfoForm = TopScrolleable(AdditionalPersonalInfoForm);

AdditionalPersonalInfoForm = reduxForm({
    form: 'AdditionalPersonalInfoForm', // a unique name for this form
    validate
})(AdditionalPersonalInfoForm);

AdditionalPersonalInfoForm = withAuthControl(AdditionalPersonalInfoForm);

export default AdditionalPersonalInfoForm;


/** WEBPACK FOOTER **
 ** ./src/components/AdditionalPersonalInfoForm.js
 **/